module.exports = __webpack_public_path__ + "media/rakuten_logo_top_bar@2x.d6a42f57.png";